import { render, staticRenderFns } from "./PatientDiseasesList.vue?vue&type=template&id=4a5f2354&scoped=true"
import script from "./PatientDiseasesList.vue?vue&type=script&lang=js"
export * from "./PatientDiseasesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5f2354",
  null
  
)

export default component.exports